//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Inform from '@/components/layer/inform.vue';
import middleLayer from '../../components/layer/middleLayer.vue'
import InstructionProtocol from '@/components/instructionProtocol/index.vue'
import AppointmentInfo from './appointment/appointmentInfo'
import BasicInfo from './appointment/basicInfo'
import { couponUse,couponPolicy } from '../../model/appointment/appointmentService';
import { store as observableStore } from "@/observable/store"
import { store } from "@/observable/store"
// import errToast from '@/components/errToast'
import clearKeepAlive from '@/utils/mixin/mixinCache'
import Txrweb from '@/utils/mixin/mixinTxrweb'
import InsuranceReview from '@/utils/mixin/InsuranceReview'
import { customer } from '@/utils/customer/index.js'

export default {
    name:'reservation-serve',
    mixins:[clearKeepAlive,Txrweb,InsuranceReview],

    data(){
        return {
            imgList:[],
            templateFlag:null,
            appointment:{ // 预约
                outpatient:null,
                time:null
            },
            info:{
                name:null,
                idCard:null,
                phone:null
            },
            load:false,
        }
    },
     computed: {
            storePhone(){
                return observableStore.phone
            },
        },
    components:{
        AppointmentInfo,
        BasicInfo,
        InstructionProtocol,
        middleLayer,
        Inform
        // errToast
    },
    created(){
       if(this.$route.query.templateFlag){
                this.templateFlag = this.$route.query.templateFlag;
            }
    },
    mounted() {
        this.scrollInto()
    },
    methods: {
        custPage(){
            customer.udesk.showPanel()

        },
         scrollInto(){
                var inputs = document.getElementsByTagName("input");
                for (var i = 0; i< inputs.length; i++) {
                    inputs[i].onblur = function (e) {
                        window.setTimeout(function () {
                            const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop ;
                            if(scrollHeight){
                              window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                            }
                            console.log(Math.max(scrollHeight - 1, 0))
                        }, 0);
                    }
                }
        },
        middleClick(){
            this.$refs.middleToast.showToast()
        },
        outpatientEmit(msg){
            this.appointment.outpatient = msg 
        },
        appointmentEmit(msg){
             this.appointment.time = msg
        },
        userNameEmit(msg){
            this.info.name = msg
        },
        telPhoneEmit(msg){
            this.info.phone = msg
        },
        idCardEmit(msg){
            this.info.idCard = msg
        },
        cancelBtn(){
            // if(this.load){
            //   return false;
            // }
            // this.load = true;
            let parameter = {
                uuid:this.$route.query.uuid,
                hospital_id:this.appointment.outpatient.hospital_id,
                appointment_at:this.appointment.time,
                phone:this.info.phone.name,
                name:this.info.name.name,
                idcard:this.info.idCard.name,
                traceback:store.TXoption.bizKey,
                template:this.templateFlag,
                last_policy_id:0
            }
            //格式化obj并核保   
            this.insuranceToReview(this.insuranceDataformat(parameter),'couponUse')

            // couponUse(parameter).then(data=>{
                
            //     // 更新可回溯信息
            //       this.updataTX(parameter,data.out_trade_no)
                
            //     setTimeout(()=>{
            //         couponPolicy(data.uuid).then(res=>{
            //                 this.$router.replace({
            //                     path: "/taStatus",
            //                     path: "/reservationStatus",
            //                     query:{
            //                         uuid:data.uuid,
            //                         order_no:res.order_no,
            //                         flag : 'postdisable',
            //                         templateFlag:this.templateFlag,
            //                     }
            //                 });
            //         }).catch((err) => {
            //             if(err.code == '1001'){
            //                 // this.$refs.errToastRef.showErrTosat();
            //                 const Message = MessageToast(MessageBox,{
            //                         contents:'请前往“我的保单”重新发起预约',
            //                         title:'预约失败',
            //                         img:"https://static.soyoung.com/sy-pre/tips-1581577800693.png", 
            //                         confirmText:'查看保单',
            //                         onConfirm:()=>{
            //                             this.goInsure()
            //                         }
            //                 })
            //                 Message.show()
            //             }
                        
            //         }).finally(()=>{
            //             this.$refs.loadingApptRef.hide();
            //             this.load = false
            //         });
            //     },5000)
            // }).catch((err) => {
            //     this.$refs.loadingApptRef.hide();
            //     this.$toast(err.message);

            //     // if(err.code == '1001'){
            //     //     this.$refs.errToastRef.showErrTosat();
            //     // }else{
            //     //     this.$toast(err.message);
            //     // }
            // }).finally(()=>{
            //     this.load = false
            // });
        },
        goInsure(){
            this.show = false;
            this.$router.replace({
                path:'/MyInsurance'
            })
        },
        immediately(){
            if(!this.appointment.outpatient){
                this.$toast("请选择预约门诊");
                return;
            }
            if(!this.appointment.time){
                this.$toast("请选择预约时间");
                return;
            }
            if(!this.info.name || !this.info.name.nameFlag){
                this.$toast("请填写正确的姓名");
                return;
            }
            if(!this.info.idCard || !this.info.idCard.idCardFlag){
                this.$toast("请填写正确的身份证号");
                return;
            }
            if(!this.info.phone ||!this.info.phone.phoneFlag){
                this.$toast("请填写正确的手机号");
                return;
            }
            if(!this.$refs.instructionProtocol.selectFlag){
                this.$toast("请认真阅读并勾选相关条款内容");
                return;
            }
            if(this.storePhone != this.info.phone.name){
                this.$alert({
                    msg:'请再次确认您的手机号为'+this.info.phone.name,
                    cancelText:'否',
                    confirmText:'是',
                    closeBtn:true,  //是否展示右上角x号
                    onCancel:()=>{
                        console.log("取消的回调")
                    },
                    onConfirm:()=>{
                        this.cancelBtn()
                    }
                })
                return;
            }
            this.cancelBtn()
        },
    }
}
